const BRAND_GLYPH_PATHS = [
    'M 25.675 40.125 C 34.013 40.125 42.03 41.498 49.513 44.031 C 49.755 44.113 49.787 44.442 49.565 44.57 L 25.824 58.277 C 25.732 58.33 25.618 58.33 25.525 58.277 L 1.785 44.57 C 1.563 44.442 1.594 44.113 1.837 44.031 C 9.319 41.499 17.337 40.125 25.675 40.125 Z',
    'M 35.557 22.953 C 31.388 15.732 28.569 8.102 27.021 0.355 C 26.971 0.104 27.24 -0.087 27.461 0.041 L 51.202 13.747 C 51.294 13.801 51.351 13.9 51.351 14.006 L 51.351 41.42 C 51.351 41.676 51.051 41.813 50.859 41.644 C 44.924 36.43 39.726 30.174 35.557 22.953 Z',
    'M 15.794 22.953 C 19.963 15.732 22.783 8.102 24.331 0.355 C 24.381 0.104 24.112 -0.087 23.89 0.041 L 0.15 13.747 C 0.057 13.801 0 13.9 0 14.006 L 0 41.42 C 0 41.676 0.3 41.813 0.493 41.644 C 6.427 36.43 11.625 30.174 15.794 22.953 Z',
];

export function BrandGlyph({ className, width = 28, height = 32 }) {
    return (
        <svg
            className={className}
            viewBox="0 0 51.351 58.317"
            width={width}
            height={height}
            aria-hidden="true"
        >
            {BRAND_GLYPH_PATHS.map((d, i) => (
                <path key={i} d={d} fill="currentColor" />
            ))}
        </svg>
    );
}
